export const VnFlag = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_27157_109178)">
        <g clipPath="url(#clip1_27157_109178)">
          <path
            d="M25.0005 0H-4.99976V20.0002H25.0005V0Z"
            fill="#FF0000"
          />
          <path
            d="M10.0003 4L6.4703 14.8501L15.7104 8.15003H4.29028L13.5304 14.8501L10.0003 4Z"
            fill="#FFEB00"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_27157_109178">
          <rect
            width="20"
            height="20"
            rx="10"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_27157_109178">
          <rect
            width="30.0002"
            height="20.0002"
            fill="white"
            transform="translate(-4.99976)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
